
import { Ticket, Calendar, Heart, Users } from "lucide-react";
import { DashboardFeature } from "./types";

export const patronFeatures: DashboardFeature[] = [
  {
    icon: Users,
    title: "Group Events",
    description: "Plan nights out with friends - hen's nights, birthdays & more",
    href: "/dashboard/group-events",
    stats: "Plan your night"
  },
  {
    icon: Ticket,
    title: "My Tickets",
    description: "View your upcoming events and ticket history",
    href: "/dashboard/tickets",
    stats: "0 upcoming events"
  },
  {
    icon: Calendar,
    title: "Event Calendar",
    description: "Discover and browse upcoming events",
    href: "/dashboard/events",
    stats: "Browse events"
  },
  {
    icon: Heart,
    title: "Saved Events",
    description: "Events you're interested in attending",
    href: "/dashboard/saved",
    stats: "0 saved"
  }
];
